import React, { useEffect, useRef, useState } from "react";
import { json, useLocation, useNavigate } from "react-router-dom";
import "./OrdersQueue.css";
import TopHeader from "../../../components/TopHeader.tsx";
import food from "../../../assets/images/food.jpg";
import SearchIcon from "../../../assets/icons/searchIcon 1.png";
import {
  AppBar,
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Dialog,
  Divider,
  Fade,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  Input,
  InputLabel,
  Link,
  List,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  Switch,
  Tab,
  Tabs,
  Toolbar,
  Typography,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import { MdTableRestaurant } from "react-icons/md";
import { FormControl } from "@mui/material";
import OrderQueueModal from "../components/OrderQueueModal.tsx";
import axios from "axios";
import back from "../../../assets/icons/back.png";
import OrderQueueCard from "./OrderQueueCard/OrderQueueCard.tsx";
import Clock from "react-live-clock";
import jwtDecode from "jwt-decode";
import OrderDetailsCardContent from "./OrderDetailsCardContent/OrderDetailsCardContent.tsx";
import AutoCompleteMultiSelect from "../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import settingsIcon from "../../../assets/icons/settingsV2.png";
import TextAreaComponents from "../../components/TextAreaComponents/TextAreaComponents.tsx";
import closeIcon from "../../../assets/icons/close.png";
import { toast, ToastContainer } from "react-toastify";
import OrderQueueSummaryCard from "./OrderQueueSummaryCards/OrderQueueSummaryCard.tsx";
import rotate from "./../../../assets/icons/rotate.png";
import fullscreen from "./../../../assets/icons/maximize.png";
import previous from "./../../../assets/icons/left-arrow.png";
import next from "./../../../assets/icons/right-arrow.png";
import close from "./../../../assets/icons/close-500.png";
import downArrow from "./../../../assets/icons/down-arrow.png";
import rowImg from "./../../../assets/images/phone.png";
import { useParams } from "react-router-dom";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { styled } from "@mui/material/styles";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { resetReload } from "../../../reduxadmin/Actions/index.js";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
const styleForOrderCancelationModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const OrdersQueue = (props) => {
  const [open, setOpen] = useState(false);
  const [openSettingsModal, setOpenSettingsModal] = useState(false);
  const [queuedCheck, setQueuedCheck] = useState(true);
  const [pendingCheck, setpendingCheck] = useState(true);
  const [preparingCheck, setpreparingCheck] = useState(true);
  const [readyCheck, setreadyCheck] = useState(true);
  const navigate = useNavigate();

  const [horizontalCheck, sethorizontalCheck] = useState(false);
  const [status, setStatus] = useState(null);
  const [quantityQueued, setQuantityQueued] = useState([]);
  const [readyFood, setReadyFood] = useState([]);
  const [queuedFood, setQueuedFood] = useState([]);
  const [pendingFood, setPendingFood] = useState([]);
  const [preparingFood, setPreparingFood] = useState([]);
  const [restaurantId, setRestaurantId] = useState(null);
  const [kitchenOpenCloseSwitch, setKitchenOpenCloseSwitch] = useState(true);
  const [cencalationReasons, setcencalationReasons] = useState(true);
  const [remarks, setRemarks] = useState("N/A");
  const [selectCencalationReason, setSelectCencalationReason] = useState();
  const [kitchenOpenCloseModal, setKitchenOpenCloseModal] = useState(false);
  const [foodModalData, setFoodModalData] = useState([]);
  const [kitchens, setKitchens] = useState([]);
  const [openKitchens, setOpenKitchens] = useState([]);
  const [closeKitchens, setCloseKitchens] = useState([]);
  const [kitchenFactory, setKitchenFactory] = useState([]);
  const [selectedkitchens, setSelectedKitchens] = useState([]);
  const [selectedkitchensForClosing, setSelectedKitchensForClosing] = useState(
    []
  );
  const [restaurantsData, setRestaurant] = useState();
  const [selectedRestaurant, setSelectedRestaurant] = useState();
  const [selectedKitchenFromModal, setSelectedKitchenFromModal] = useState([]);
  const [selectedQueue, setSelectedQueue] = useState(0);
  const [kitchenQueueSettings, setKitchenQueueSettings] = useState({
    id: "string",
    kitchenId: kitchens?.id,
    queueId: selectedQueue,
    restaurantId: restaurantId,
    isAutoAcceptEnable: false,
    maxQty: "",
    autoAcceptFrequency: "",
    threasholdQty: 0,
    frequencyUpdateTime: "2024-09-20T11:52:40.783",
    isThresholdEnable: false,
  });
  const [isAutoAcceptEnable, setIsAutoAcceptEnable] = useState(true);
  const [maxQty, setMaxQty] = useState();
  const [autoAcceptFrequency, setAutoAcceptFrequency] = useState();
  const [threasholdQty, setThreasholdQty] = useState();
  const [value, setValue] = React.useState("one");
  // Getting kitchen id
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const kitchenId = queryParams.get("kitchenId");
  const [ordercount, setOrderCount] = useState(-1);

  useEffect(() => {
    // if (kitchenId == 25 || kitchenId == 29) {
    //   if (selectedkitchens.length === 0) {
    //     const waiterKitchenView = kitchens.find(
    //       (x) => x.title === "Waiter View"
    //     );
    //     const otherKitchens = kitchens.filter(
    //       (x) => x.title !== "Waiter View" && x.title !== "Manager View"
    //     );

    //     const filteredKitchens = [];

    //     // Add "Waiter View" if it exists
    //     if (waiterKitchenView) {
    //       filteredKitchens.push(waiterKitchenView);
    //     }

    //     // Add remaining kitchens, avoiding duplicates
    //     otherKitchens.forEach((kitchen) => {
    //       filteredKitchens.push(kitchen);
    //     });

    //     console.log(filteredKitchens);
    //     setSelectedKitchens(filteredKitchens);
    //   }
    // } else {

    // }
    let kitckenList = [];
    const foundKitchen = kitchens.find(
      (data) => String(data.id) === String(kitchenId)
    );

    if (foundKitchen) {
      kitckenList.push(foundKitchen);
      setSelectedKitchens(kitckenList);
    } else {
      let foundManagerKitchen = kitchens.find(
        (data) => String(data.title) === String("Manager View")
      );
      if (foundManagerKitchen) {
        kitckenList.push(foundManagerKitchen);
        setSelectedKitchens(kitckenList);
        getOrdersByOrderStatusForWaiterView(kitckenList);
      }
    }
    if (kitckenList.some((x) => x.title == "Waiter View")) {
      getOrdersByOrderStatusForWaiterView(kitckenList);
    }
  }, [kitchenId, kitchens]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClose = () => {
    setOpen(false);
    setKitchenOpenCloseModal(false);
  };

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "35%",
    bgcolor: "background.paper",
    boxShadow: 24,
    px: 4,
    py: 2,
  };

  // useEffect(() => {
  //   const broadcastChannel = new BroadcastChannel("loadQueue");

  //   // Define the event handler
  //   const handleMessage = (event) => {
  //     if (event.data === "loadQueueDatas") {
  //       getOrdersByOrderStatus(); // Function that should run when message is received
  //     }
  //   };

  //   // Add the event listener
  //   broadcastChannel.addEventListener("message", handleMessage);

  //   // Cleanup on unmount
  //   return () => {
  //     broadcastChannel.removeEventListener("message", handleMessage);
  //     broadcastChannel.close();
  //   };
  // });

  const dispatch = useDispatch();
  const shouldReload = useSelector(
    (state) => state.kitchenReducer.shouldReload
  );

  const playNotificationSound = () => {
    try {
      const audio = new Audio(
        "https://gotastelivestorage.blob.core.windows.net/gotasteimages/ringtone-021-365652.mp3"
      );
      audio.volume = 0.5;
      audio.play().catch((err) => {
        console.warn("Audio play prevented (user gesture required):", err);
      });
    } catch (err) {
      console.error("Error playing notification sound:", err);
    }
  };

  useEffect(() => {
    if (shouldReload) {
      console.log("Reload triggered by SignalR");
      getOrdersByOrderStatus();
      dispatch(resetReload());
    }
  }, [shouldReload, dispatch]);

  const getOrdersByOrderStatusForWaiterView = async (prop) => {
    try {
      if (restaurantId) {
        let foundWaitersKitchen = prop.find(
          (data) => String(data.title) === String("Waiter View")
        );
        var waiterKithchen = [...prop];
        if (selectedkitchens.length == 0) {
          // Start with selected kitchens

          // Get the filtered kitchens that are not already in waiterKithchen
          var filteredKitchens = kitchens.filter(
            (x) => x.title !== "Waiter View" && x.title !== "Manager View"
          );
          // Ensure no duplicates are added
          filteredKitchens.forEach((kitchen) => {
            if (!waiterKithchen.some((wk) => wk.id === kitchen.id)) {
              waiterKithchen.push(kitchen);
            }
          });
          setSelectedKitchens(waiterKithchen);
        }

        if (foundWaitersKitchen) {
          const kitchenIds = waiterKithchen.map((kitchen) => kitchen.id);
          const orders = await axios
            .post(
              `${process.env.REACT_APP_SECRET}/api/QueueManagement/GetOngoingOrdersByUserIdForWaiter?restaurantId=` +
                restaurantId,
              kitchenIds
            )
            .then((res) => {
              setQueuedFood(res.data.queueOrders);
              setPendingFood(res.data.pendingQueueOrders);
              setPreparingFood(res.data.preparingQueueOrders);
              setReadyFood(res.data.readyQueueOrders);
              var obj = {
                queuedQty: res.data.queueOrders.length,
                preparingQty: res.data.preparingQueueOrders.length,
                pendingQty: res.data.pendingQueueOrders.length,
                readyQty: res.data.readyQueueOrders.length,
              };
              setQuantityQueued(obj);
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getOrdersByOrderStatus = async () => {
    try {
      if (restaurantId) {
        //   const orders = await axios
        //     .get(
        //       `${process.env.REACT_APP_SECRET}/api/QueueManagement?restaurantId=` +
        //       restaurantId
        //     )
        //     .then((res) => {
        //       setQueuedFood(res.data.queueOrders);
        //       setPendingFood(res.data.pendingQueueOrders);
        //       setPreparingFood(res.data.preparingQueueOrders);
        //       setReadyFood(res.data.readyQueueOrders);
        //       var obj = {
        //         queuedQty: res.data.queueOrders.length,
        //         preparingQty: res.data.preparingQueueOrders.length,
        //         pendingQty: res.data.pendingQueueOrders.length,
        //         readyQty: res.data.readyQueueOrders.length,
        //       };
        //       setQuantityQueued(obj);

        //         console.log(queuedFood)
        //         console.log(pendingFood)
        //         console.log(preparingFood)
        //         console.log(readyFood)
        //     })
        //     .catch((ex) => {
        //       console.log(ex);
        //     });
        // }

        let foundManagerKitchen = selectedkitchens.find(
          (data) => String(data.title) === String("Manager View")
        );

        if (kitchenId == null && foundManagerKitchen) {
          const orders = await axios
            .get(
              `${process.env.REACT_APP_SECRET}/api/QueueManagement?restaurantId=` +
                restaurantId
            )
            .then((res) => {
              const queueOrders = res.data.queueOrders;
              const pendingOrders = res.data.pendingQueueOrders;
              const preparingOrders = res.data.preparingQueueOrders;
              const readyOrders = res.data.readyQueueOrders;

              const allOrders = [
                ...queueOrders.map((o) => ({ ...o, status: "queue" })),
                ...pendingOrders.map((o) => ({ ...o, status: "pending" })),
                ...preparingOrders.map((o) => ({ ...o, status: "preparing" })),
                ...readyOrders.map((o) => ({ ...o, status: "ready" })),
              ];

              const statusRank = {
                queue: 1,
                pending: 2,
                preparing: 3,
                ready: 4,
              };

              const groupedOrders = {};

              allOrders.forEach((order) => {
                const id = order.id;

                if (!groupedOrders[id]) {
                  groupedOrders[id] = {
                    keyStatus: order.status,
                    orders: [order],
                  };
                } else {
                  if (
                    statusRank[order.status] <
                    statusRank[groupedOrders[id].keyStatus]
                  ) {
                    groupedOrders[id].keyStatus = order.status;
                  }
                  groupedOrders[id].orders.push(order);
                }
              });

              const finalQueued = [];
              const finalPending = [];
              const finalPreparing = [];
              const finalReady = [];

              Object.values(groupedOrders).forEach((order) => {
                switch (order.keyStatus) {
                  case "queue":
                    order.orders.forEach((d) => {
                      finalQueued.push(d);
                    });
                    break;
                  case "pending":
                    order.orders.forEach((d) => {
                      finalPending.push(d);
                    });
                    break;
                  case "preparing":
                    order.orders.forEach((d) => {
                      finalPreparing.push(d);
                    });
                    break;
                  case "ready":
                    order.orders.forEach((d) => {
                      finalReady.push(d);
                    });

                    break;
                }
              });

              setQueuedFood(finalQueued);
              setPendingFood(finalPending);
              setPreparingFood(finalPreparing);
              setReadyFood(finalReady);

              console.log("Final Queued Orders:", finalQueued);
              console.log("Final Pending Orders:", finalPending);
              console.log("Final Preparing Orders:", finalPreparing);
              console.log("Final Ready Orders:", finalReady);

              if (allOrders.length > ordercount && ordercount !== -1) {
                // try {
                //   const audio = new Audio(
                //     "https://gotastelivestorage.blob.core.windows.net/gotasteimages/ringtone-021-365652.mp3"
                //   );
                //   audio.volume = 0.5;
                //   audio
                //     .play()
                //     .catch((err) =>
                //       console.warn(
                //         "Audio play prevented (user gesture required):",
                //         err
                //       )
                //     );
                // } catch (err) {
                //   console.error("Error playing notification sound:", err);
                // }
              }
              setOrderCount(
                finalQueued.length +
                  finalPending.length +
                  finalPreparing.length +
                  finalReady.length
              );

              var obj = {
                queuedQty: finalQueued.length,
                preparingQty: finalPreparing.length,
                pendingQty: finalPending.length,
                readyQty: finalReady.length,
              };
              setQuantityQueued(obj);
            });
        } else {
          await getOrdersByOrderStatusByKitchenId();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getOrdersByOrderStatusByKitchenId = async () => {
    try {
      if (selectedkitchens) {
        let foundManagerKitchen = selectedkitchens.find(
          (data) => String(data.title) === String("Manager View")
        );

        let foundWaitersKitchen = selectedkitchens.find(
          (data) => String(data.title) === String("Waiter View")
        );

        if (foundManagerKitchen) {
          await getOrdersByOrderStatus();
        } else if (foundWaitersKitchen) {
          //await getOrdersByOrderStatus()
          // await getOrdersByOrderStatusForWaiterView();
          return;
        } else {
          const kitchenIds = selectedkitchens.map((kitchen) => kitchen.id);

          const orders = await axios
            .post(
              `${process.env.REACT_APP_SECRET}/api/QueueManagement/GetAllQueueManagementDataByRestaurantIdAndKitchenId?restaurantId=` +
                restaurantId,
              kitchenIds
            )
            .then((res) => {
              setQueuedFood(res.data.queueOrders);
              setPendingFood(res.data.pendingQueueOrders);
              setPreparingFood(res.data.preparingQueueOrders);
              setReadyFood(res.data.readyQueueOrders);
              var obj = {
                queuedQty: res.data.queueOrders.length,
                preparingQty: res.data.preparingQueueOrders.length,
                pendingQty: res.data.pendingQueueOrders.length,
                readyQty: res.data.readyQueueOrders.length,
              };
              setQuantityQueued(obj);
              const allOrdersCount =
                res.data.queueOrders.length +
                res.data.pendingQueueOrders.length +
                res.data.preparingQueueOrders.length +
                res.data.readyQueueOrders.length;

              if (allOrdersCount > ordercount && ordercount !== -1) {
                // try {
                //   const audio = new Audio(
                //     "https://gotastelivestorage.blob.core.windows.net/gotasteimages/ringtone-021-365652.mp3"
                //   );
                //   audio.volume = 0.5;
                //   audio
                //     .play()
                //     .catch((err) =>
                //       console.warn(
                //         "Audio play prevented (user gesture required):",
                //         err
                //       )
                //     );
                // } catch (err) {
                //   console.error("Error playing notification sound:", err);
                // }
              }
              setOrderCount(allOrdersCount);
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const loadRestaurantKitchens = async () => {
    try {
      if (restaurantId) {
        const orders = await axios
          .get(
            `${process.env.REACT_APP_SECRET}/api/Kitchen/GetAllKitchensByRestaurantId/` +
              restaurantId
          )
          .then((res) => {
            var list = [];
            res.data.map((data) => {
              const obj = {
                id: data.id,
                title: data.name,
                isOpen: data.isActive,
              };
              list.push(obj);
            });

            // if (kitchenId) {
            //   list = list.filter(
            //     (x) => x.title !== "Manager View" && x.title !== "Waiter View"
            //   );
            // }

            setOpenKitchens(list.filter((x) => x.isOpen));
            setCloseKitchens(list.filter((x) => !x.isOpen));
            setKitchens(list);

            setKitchenFactory(res.data);
          })
          .catch((ex) => {
            console.log(ex);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [wakeLock, setWakeLock] = useState(null);

  // Function to request the wake lock
  const requestWakeLock = async () => {
    try {
      const lock = await navigator.wakeLock.request("screen");
      setWakeLock(lock);

      // Listen for release of wake lock
      lock.addEventListener("release", () => {
        console.log("Wake Lock was released");
        setWakeLock(null);
      });

      console.log("Wake Lock is active");
    } catch (err) {
      console.error(`Wake Lock request failed: ${err.message}`);
    }
  };

  // Function to release the wake lock
  const releaseWakeLock = () => {
    if (wakeLock) {
      wakeLock.release();
      setWakeLock(null);
    }
  };

  useEffect(() => {
    // Request the wake lock when the component is mounted
    requestWakeLock();

    // Release the wake lock when the component is unmounted
    return () => {
      releaseWakeLock();
    };
  }, []);

  useEffect(() => {
    getOrdersByOrderStatus();
    loadRestaurantKitchens();
  }, [restaurantId]);

  const [switchCollapsableCheck, setswitchCollapsableCheck] = useState(false);
  const handleswitchCollapsableCheck = () => {
    setswitchCollapsableCheck(!switchCollapsableCheck);
  };

  const formatTime = (dateTimeString) => {
    if (dateTimeString) {
      // Normalize the date-time string to a format that can be parsed by the Date object
      const normalizedDateTimeString = dateTimeString.replace(/\.\d+/, ""); // Remove milliseconds

      // Create a Date object from the normalized date-time string
      const dateObject = new Date(normalizedDateTimeString);

      // Check if the date is valid
      if (isNaN(dateObject)) {
        return "Invalid Date";
      }

      // Extract only the time with AM/PM format (e.g., "HH:mm:ss AM/PM")
      const timeOnly = dateObject.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true, // Set to true for 12-hour format with AM/PM
      });

      return timeOnly;
    } else {
      return "N/A";
    }
  };

  const loadKitchenQueueSettings = async (e) => {
    try {
      if (restaurantId && e) {
        const orders = await axios
          .get(
            `${process.env.REACT_APP_SECRET}/api/Kitchen/GetKitchenQueueManagementSettingsByKitchenAndRestaurantAndQueue?kitchenId=` +
              e.id +
              "&restaurantId=" +
              restaurantId +
              "&queueId=" +
              selectedQueue
          )
          .then((res) => {
            if (res.data) {
              setKitchenQueueSettings(res.data);
            } else {
              setKitchenQueueSettings({
                id: "string",
                kitchenId: e.id,
                queueId: selectedQueue,
                restaurantId: restaurantId,
                isAutoAcceptEnable: false,
                maxQty: "",
                autoAcceptFrequency: "",
                threasholdQty: 0,
                frequencyUpdateTime: "2024-09-20T11:52:40.783",
                isThresholdEnable: false,
              });
            }
          })

          .catch((ex) => {
            console.log(ex);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleUpdateKitchenSettings = async () => {
    kitchenQueueSettings.frequencyUpdateTime = new Date().toISOString();
    const orders = await axios
      .put(
        `${process.env.REACT_APP_SECRET}/api/Kitchen/UpdateIntoKitchenQueueManagementSettings`,
        kitchenQueueSettings
      )
      .then((res) => {
        handleClose();
        toast.success("Successfully Updated", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((ex) => {});
  };

  const clearKitchenQueueSettings = () => {
    setKitchenQueueSettings({
      id: "string",
      kitchenId: "",
      queueId: "",
      restaurantId: "",
      isAutoAcceptEnable: false,
      maxQty: "",
      autoAcceptFrequency: "",
      threasholdQty: 0,
      frequencyUpdateTime: "",
      isThresholdEnable: false,
    });
  };

  useEffect(() => {
    if (selectedkitchens.length > 0) {
      getOrdersByOrderStatusByKitchenId();
      var obj = kitchenFactory.find((x) => x.id == selectedkitchens.id);
      setKitchenOpenCloseSwitch(obj?.isActive);
    } else {
      //getOrdersByOrderStatus();
    }
  }, [selectedkitchens]);

  const getAllKitchenClosingReason = async () => {
    await axios
      .get(`${process.env.REACT_APP_SECRET}/api/KitchenClosingReason`)
      .then((res) => {
        var list = [];
        res.data.map((dt) => {
          var obj = {
            id: dt.id,
            title: dt.reason,
          };
          list.push(obj);
        });
        setcencalationReasons(list);
      });
  };

  const handleCloseKitchen = async (data, status) => {
    var list = [];
    data.map((dt, i) => {
      var obj = {
        id: 0,
        kitchenId: dt?.id,
        closingReasonId: selectCencalationReason?.id,
        remarks: remarks,
        isClosed: status,
        closedDate: "2024-10-18T12:22:57.232Z",
      };
      list.push(obj);
    });
    await axios
      .post(`${process.env.REACT_APP_SECRET}/api/KitchenClosingReason`, list)
      .then((res) => {
        toast.success("Saved Successfully");
        setKitchenOpenCloseModal(false);
        loadRestaurantKitchens();
      })
      .catch((err) => {
        toast.error("Unable to close restaurant");
      });
  };

  const handleClosingSwitch = async () => {
    setKitchenOpenCloseModal(true);
    setSelectedKitchensForClosing(selectedkitchens);
  };
  const loadRestaurantData = () => {
    const apiAddress = process.env.REACT_APP_SECRET;
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwtDecode(token);

        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
      } catch (error) {}
    }
    const restaurant = JSON.parse(localStorage.getItem("parentrestaurant"));
    axios
      .get(
        apiAddress +
          "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
          decodedData.UserId +
          "/" +
          restaurant.id
      )
      .then((response) => {
        var list = [];
        // list.push(response.data)
        // setRestaurantDatas(list);
        response.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            title: dt.name,
            address: dt.addressLine1,
            PhoneNumber: dt.phoneNumber,
            Email: dt.emailAddress,
          };
          list.push(obj);
        });

        setRestaurant(list);
      });
  };
  useEffect(() => {
    const restaurant = localStorage.getItem("restaurant");
    const restaurantObject = JSON.parse(restaurant);
    setRestaurantId(restaurantObject?.id);
    loadRestaurantData();
  }, []);

  useEffect(() => {
    const restaurant = localStorage.getItem("restaurant");
    const restaurantObject = JSON.parse(restaurant);

    let restaurantList = [];
    const foundres = restaurantsData?.find(
      (data) => data.id === restaurantObject?.id
    );

    if (foundres) {
      //restaurantList.push(foundres)
      setSelectedRestaurant(foundres);
    }
  }, [restaurantsData]);

  useEffect(() => {
    if (selectedRestaurant) {
      setRestaurantId(selectedRestaurant?.id);
    }
  }, [selectedRestaurant]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openDropdown = Boolean(anchorEl);
  const [disableCancelBtn, setDisableCancelBtn] = useState(false);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>, queueId) => {
    setAnchorEl(event.currentTarget);
    setSelectedQueue(queueId);
    switch (queueId) {
      case 1:
        queuedFood?.length > 0
          ? setDisableCancelBtn(false)
          : setDisableCancelBtn(true);
        break;
      case 2:
        pendingFood?.length > 0
          ? setDisableCancelBtn(false)
          : setDisableCancelBtn(true);
        break;
      case 3:
        preparingFood?.length > 0
          ? setDisableCancelBtn(false)
          : setDisableCancelBtn(true);
        break;
    }
  };
  const handleDropDownClose = () => {
    setAnchorEl(null);
  };

  const handleSettingsModalOpen = (queueId) => {
    setOpen(true);
    getAllKitchenClosingReason();
    setKitchenQueueSettings(null);
  };

  const [openOrderCancelationModal, setOpenOrderCancelationModal] =
    React.useState(false);
  const handleOpenOrderCancelationModal = async () => {
    await getAllKitchenClosingReason();
    setOpenOrderCancelationModal(true);
  };

  const handleCloseOrderCancelationModal = () =>
    setOpenOrderCancelationModal(false);

  const handleCancelOrders = async () => {
    var ids;
    var idsAndKitchenIds;
    var KitchenIds;
    switch (selectedQueue) {
      case 1:
        idsAndKitchenIds = queuedFood.map((x) => ({
          orderId: x.id,
          kitchenId: x.kitchenId,
        }));
        break;
      case 2:
        idsAndKitchenIds = pendingFood.map((x) => ({
          orderId: x.id,
          kitchenId: x.kitchenId,
        }));
        break;
      case 3:
        idsAndKitchenIds = preparingFood.map((x) => ({
          orderId: x.id,
          kitchenId: x.kitchenId,
        }));
        break;
    }
    var obj = {
      id: 0,
      OrderIdAndKitchens: idsAndKitchenIds,
      statusId: "IS006",
      isRefunded: true,
      cancelationReasonId:
        selectCencalationReason?.id != undefined
          ? selectCencalationReason?.id
          : "CR007",
      cancelationReason:
        selectCencalationReason?.title != undefined
          ? selectCencalationReason?.title
          : "Not Provided",
      remarks: remarks,
      restaurantId: restaurantId,
    };
    await axios
      .post(
        `${process.env.REACT_APP_SECRET}/api/Order/CancelMultipleOrdersOrder`,
        obj
      )
      .then((res) => {
        toast.success("Order successfully canceled", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setOpenOrderCancelationModal(false);
        getOrdersByOrderStatus();
      });
  };

  const QueueRef = useRef(null);
  const PendingRef = useRef(null);
  const PreparingRef = useRef(null);
  const ReadyRef = useRef(null);

  // Setting current ref
  const [currentRef, setCurrentRef] = useState("Queue");
  const [buttonClicked, setButtonclicked] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (horizontalCheck) {
        const queueRect = QueueRef.current?.getBoundingClientRect();
        const pendingRect = PendingRef.current?.getBoundingClientRect();
        const preparingRect = PreparingRef.current?.getBoundingClientRect();
        const readyRect = ReadyRef.current?.getBoundingClientRect();

        if (
          queueRect &&
          queueRect.top >= 0 &&
          queueRect.top <= window.innerHeight
        ) {
          setCurrentRef("Queue");
        } else if (
          pendingRect &&
          pendingRect.top >= 0 &&
          pendingRect.top <= window.innerHeight
        ) {
          setCurrentRef("Pending");
        } else if (
          preparingRect &&
          preparingRect.top >= 0 &&
          preparingRect.top <= window.innerHeight
        ) {
          setCurrentRef("Preparing");
        } else if (
          readyRect &&
          readyRect.top >= 0 &&
          readyRect.top <= window.innerHeight
        ) {
          setCurrentRef("Ready");
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [buttonClicked]);

  const scrollTo = (ref) => {
    if (ref.current) {
      const targetPosition =
        ref.current.getBoundingClientRect().top + window.pageYOffset;
      const startPosition = window.pageYOffset;
      const distance = targetPosition - startPosition;
      const duration = 300;
      let startTime = null;

      // Function for the animation
      const animateScroll = (currentTime) => {
        if (!startTime) startTime = currentTime;

        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        const scrollPosition = startPosition + distance * progress;

        window.scrollTo(0, scrollPosition);

        if (timeElapsed < duration) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    }
  };

  const scrollToPreparingQueue = (direction) => {
    setButtonclicked(!buttonClicked);
    if (direction === "up") {
      switch (currentRef) {
        case "Pending":
          scrollTo(QueueRef);
          break;
        case "Preparing":
          scrollTo(PendingRef);
          break;
        case "Ready":
          scrollTo(PreparingRef);
          break;
      }
    } else {
      switch (currentRef) {
        case "Queue":
          scrollTo(PendingRef);
          break;
        case "Pending":
          scrollTo(PreparingRef);
          break;
        case "Preparing":
          scrollTo(ReadyRef);
          break;
      }
    }
  };
  /** end of next-previous functionality */

  const [modalData, setModalData] = useState([]);
  const updateModalData = (data) => {
    setModalData(data);
  };

  const [detailsModelOpen, setDetailsModelOpen] = useState(false);
  const [sectionName, setSectionName] = useState("");
  const openDetailsModal = (queuedFoodParameters, boxName, usedIN) => {
    setSectionName(boxName);
    updateModalData(queuedFoodParameters);

    if (usedIN !== "def") {
      setDetailsModelOpen(!detailsModelOpen);
    }
  };

  const changeModalData = (queuedFoodParameters, boxName) => {
    // setDetailsModelOpen(!detailsModelOpen);
    setSectionName(boxName);
    updateModalData(queuedFoodParameters);
  };

  const updateData = (section) => {
    switch (section) {
      case "Queue":
        updateModalData(queuedFood);
        break;
      case "Pending":
        updateModalData(pendingFood);
        break;
      case "Preparing":
        updateModalData(preparingFood);
        break;
      case "Ready":
        updateModalData(readyFood);
        break;
      default:
    }
  };

  useEffect(() => {
    updateData(sectionName);
  }, [queuedFood, pendingFood, readyFood, preparingFood]);

  const handleCloseDetailsModel = () => {
    setDetailsModelOpen(!detailsModelOpen);
  };

  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  };

  const filterData = (data, term) => {
    return data.filter((item) => {
      return JSON.stringify(item).toLowerCase().includes(term);
    });
  };
  useEffect(() => {
    let filteredData = [];
    switch (sectionName) {
      case "Queue":
        filteredData = filterData(queuedFood, searchTerm);
        updateModalData(filteredData);
        break;
      case "Pending":
        filteredData = filterData(pendingFood, searchTerm);
        updateModalData(filteredData);
        break;
      case "Preparing":
        filteredData = filterData(preparingFood, searchTerm);
        updateModalData(filteredData);
        break;
      case "Ready":
        filteredData = filterData(readyFood, searchTerm);
        updateModalData(filteredData);
        break;
      default:
    }
  }, [searchTerm]);

  const activeTab = [
    ...(queuedCheck ? [] : ["queued"]),
    ...(pendingCheck ? [] : ["pending"]),
    ...(preparingCheck ? [] : ["preparing"]),
    ...(readyCheck ? [] : ["ready"]),
  ];

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 320,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }));

  const getBackgroundColor = (sectionName) => {
    switch (sectionName) {
      case "Queue":
        return "#ef5350"; // Red
      case "Pending":
        return "#f39c12"; // Orange
      case "Preparing":
        return "#2980b9"; // Blue
      case "Ready":
        return "#27ae60"; // Green
      default:
        return "#ffffff"; // Default white background
    }
  };
  const [SearchIconStatus, setSearchIconStatus] = useState(false);

  const handleSearchIconClick = () => {
    setSearchIconStatus(!SearchIconStatus);
  };

  const groupedOrdersPending = pendingFood?.reduce((acc, order) => {
    const existingOrder = acc.find((o) => o.id === order.id);

    if (existingOrder) {
      // Combine kitchens and subOrders if the orderId already exists
      existingOrder.kitchenViews = [
        ...existingOrder.kitchenViews,
        ...order.kitchenViews,
      ];
      existingOrder.subOrders = [
        ...(existingOrder.subOrders || []),
        ...(order.subOrders || []),
      ];
    } else {
      // Add a new order entry
      acc.push({ ...order });
    }

    return acc;
  }, []);

  const [showAutoComplete, setShowAutoComplete] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAutoComplete(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const headerTabClicked = (data) => {
    switch (data) {
      case "Queue":
        openDetailsModal(queuedFood, data, "def");
        break;
      case "Preparing":
        openDetailsModal(preparingFood, data, "def");
        break;
      case "Pending":
        openDetailsModal(pendingFood, data, "def");
        break;
      case "Ready":
        openDetailsModal(readyFood, data, "def");
        break;
    }
  };

  const reloadOrders = () => {
    let foundWaitersKitchen = selectedkitchens.find(
      (data) => String(data.title) === String("Waiter View")
    );
    if (foundWaitersKitchen) {
      getOrdersByOrderStatusForWaiterView(selectedkitchens);
    } else {
      if (kitchenId) getOrdersByOrderStatusByKitchenId();
      else getOrdersByOrderStatus();
    }
  };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     window.location.reload();
  //   }, 45 * 60 * 1000);

  //   // Cleanup the interval on component unmount
  //   return () => clearInterval(interval);
  // }, []);

  return (
    <div className="order-queue">
      {/* {JSON.stringify(selectedkitchens)} */}

      <TopHeader></TopHeader>

      {/* Menu Option - cancle order/setting */}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openDropdown}
        onClose={handleDropDownClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          className="text-center"
          onClick={handleOpenOrderCancelationModal}
          disabled={disableCancelBtn}
        >
          Cancel All Order
        </MenuItem>
        <MenuItem
          className="text-center"
          onClick={() => {
            handleSettingsModalOpen(1);
          }}
        >
          Settings
        </MenuItem>
      </Menu>

      {/* <ToastContainer /> */}

      {/* Main Container */}
      <div className="queue-container">
        <div
          className="d-flex"
          style={{
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div
            className="d-flex"
            style={{
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
              width: "100%",
              padding: "10px",
            }}
          >
            <div
              onClick={() => {
                navigate(-1);
              }}
              style={{ cursor: "pointer" }}
            >
              <img src={back} style={{ width: "1rem" }} />
            </div>
            <div className="fs-2 fw-bold my-3 text-center">On Going Orders</div>
            <div></div>

            {/* <FormControlLabel
              className="mt-2"
              control={
                <Switch
                  checked={kitchenOpenCloseSwitch}
                  onChange={() => {
                    handleClosingSwitch();
                  }}
                />
              }
              label="Open"
            /> */}
          </div>
          {/* Clock Section */}
          <div>
            <Clock
              format={"h:mm:ss A"}
              style={{ fontSize: "1.5em" }}
              ticking={true}
            />
          </div>
        </div>

        <div className="row mb-2 d-flex justify-content-center mt-2">
          <div className="col-4 d-flex justify-content-between mt-2">
            <div className="w-100 d-flex">
              <div className="w-100 ">
                {showAutoComplete && (
                  <AutoCompleteMultiSelect
                    id={33}
                    datas={restaurantsData}
                    value={(e) => {
                      setSelectedRestaurant(e);
                    }}
                    val={selectedRestaurant}
                    placeholder={"Select Restaurant"}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="col-4 d-flex justify-content-between mt-2">
            <div className="w-100 d-flex">
              <div className="w-100 ">
                {showAutoComplete && (
                  <AutoCompleteMultiSelect
                    id={2}
                    datas={kitchens}
                    value={(e) => {
                      const hadWaiterView = selectedkitchens.some(
                        (x) => x.title === "Waiter View"
                      );
                      const hasWaiterViewNow = e.some(
                        (x) => x.title === "Waiter View"
                      );

                      if (hadWaiterView && !hasWaiterViewNow) {
                        toast.warn("Can not remove waiter's view.");
                        return;
                      }

                      const hadManagerView = selectedkitchens.some(
                        (x) => x.title === "Manager View"
                      );
                      const hasManagerViewNow = e.some(
                        (x) => x.title === "Manager View"
                      );

                      if (hadManagerView && !hasManagerViewNow) {
                        toast.warn("Can not remove manager's view.");
                        return;
                      }

                      if (
                        selectedkitchens.some(
                          (x) => x.title == "Waiter View"
                        ) &&
                        e.some((x) => x.title == "Manager View")
                      ) {
                        toast.warn(
                          "Manager's view can not selected when waiter's view is selected"
                        );
                        return;
                      } else if (
                        selectedkitchens.some(
                          (x) => x.title == "Manager View"
                        ) &&
                        e.some((x) => x.title == "Waiter View")
                      ) {
                        toast.warn(
                          "Waiter's view can not selected when manager's view is selected"
                        );
                        return;
                      }

                      const isWaiterKitchenViewSelected =
                        // selectedkitchens.some((kitchen) => kitchen.id === 29) ||
                        e.some((kitchen) => kitchen.title === "Waiter View") ||
                        e.some((kitchen) => kitchen.id === 25);

                      if (isWaiterKitchenViewSelected) {
                        setSelectedKitchens(e);
                        getOrdersByOrderStatusForWaiterView(e);
                        return;
                      } else {
                        setSelectedKitchens(e);
                      }
                    }}
                    // value={(e) => {
                    //   setSelectedKitchens(e);
                    // }}
                    val={selectedkitchens}
                    placeholder={"Select Kitchen"}
                  />
                )}
              </div>

              <Button
                onClick={() => {
                  handleClosingSwitch();
                  getAllKitchenClosingReason();
                  setValue("one");
                }}
              >
                <img src={settingsIcon} style={{ width: "1rem" }} />
              </Button>
            </div>
          </div>
        </div>

        <Grid
          xs={12}
          className="d-flex mb-2 "
          sx={{ justifyContent: "center" }}
        >
          <FormControlLabel
            value="Queued"
            control={
              <Checkbox
                checked={queuedCheck}
                onChange={() => {
                  setQueuedCheck(!queuedCheck);
                }}
              />
            }
            label="Queued"
          />
          <FormControlLabel
            value="Pending"
            control={
              <Checkbox
                checked={pendingCheck}
                onChange={() => {
                  setpendingCheck(!pendingCheck);
                }}
              />
            }
            label="Pending"
          />
          <FormControlLabel
            value="Preparing"
            control={
              <Checkbox
                checked={preparingCheck}
                onChange={() => {
                  setpreparingCheck(!preparingCheck);
                }}
              />
            }
            label="Preparing"
          />
          <FormControlLabel
            value="Ready"
            control={
              <Checkbox
                checked={readyCheck}
                onChange={() => {
                  setreadyCheck(!readyCheck);
                }}
              />
            }
            label="Ready"
          />
          <div
            onClick={() => {
              sethorizontalCheck(!horizontalCheck);
            }}
            className="d-flex"
            style={{ justifyContent: "end", cursor: "pointer" }}
          >
            {/* {horizontalCheck ? (
            <img src={columnImg} style={{ width: "1.3rem" }} />
          ) : (
            <img src={rowImg} style={{ width: "1.3rem" }} />
          )}
           */}
            <img
              src={rotate}
              style={{ width: "1.3rem", objectFit: "contain" }}
            />
          </div>
          {/* <FormControlLabel
            value="Row"
            control={
              <Checkbox
                checked={horizontalCheck}
                onChange={() => {
                  sethorizontalCheck(!horizontalCheck);
                }}
              />
            }
            label="Row"
          /> */}
        </Grid>

        {/* Order Queue Summary */}
        <OrderQueueSummaryCard
          quantityQueued={quantityQueued}
          activeTab={activeTab}
          onQueuedClick={() => {
            setQueuedCheck(!queuedCheck);
          }}
          onPendingClick={() => {
            setpendingCheck(!pendingCheck);
          }}
          onPreparingClick={() => {
            setpreparingCheck(!preparingCheck);
          }}
          onReadyClick={() => {
            setreadyCheck(!readyCheck);
          }}
        />

        {/* FullScreen Modal Code */}
        <Dialog fullScreen open={detailsModelOpen} onClose={handleClose}>
          <AppBar
            sx={{
              position: "relative",
              zIndex: "1202",
              backgroundColor: getBackgroundColor(sectionName),
            }}
          >
            <Toolbar>
              {/* Section Header and counting  */}
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                {sectionName} {/* Section Quantity */}(
                {(() => {
                  switch (sectionName) {
                    case "Queue":
                      return `${quantityQueued.queuedQty}`;
                    case "Pending":
                      return `${quantityQueued.pendingQty}`;
                    case "Preparing":
                      return `${quantityQueued.preparingQty}`;
                    case "Ready":
                      return `${quantityQueued.readyQty}`;
                  }
                })()}
                ){/* Search Box */}
                <IconButton
                  style={{ marginLeft: "10px" }}
                  edge="start"
                  color="inherit"
                  onClick={handleSearchIconClick}
                  aria-label="close"
                >
                  <img
                    src={SearchIcon}
                    style={{ width: "20px", height: "20px" }}
                  />
                </IconButton>
                {SearchIconStatus && (
                  // <input style={{ marginLeft: '10px', paddingLeft: '10px', background: 'rgb(255 255 255 / 89%)', border: '1px solid gray' }} placeholder={`Search In ${sectionName}`} />
                  <input
                    style={{
                      marginLeft: "10px",
                      paddingLeft: "10px",
                      background: "rgb(255 255 255 / 89%)",
                      border: "1px solid gray",
                    }}
                    placeholder={`Search`}
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                )}{" "}
                |
                {(() => {
                  switch (sectionName) {
                    case "Queue":
                      return (
                        <span style={{ cursor: "pointer" }}>
                          <span
                            className="ms-1"
                            onClick={() => headerTabClicked("Pending")}
                          >
                            Pending ({quantityQueued.pendingQty}) |
                          </span>
                          <span
                            className="ms-1"
                            onClick={() => headerTabClicked("Preparing")}
                          >
                            Preparing ({quantityQueued.preparingQty}) |
                          </span>
                          <span
                            className="ms-1"
                            onClick={() => headerTabClicked("Ready")}
                          >
                            Ready ({quantityQueued.readyQty})
                          </span>
                        </span>
                      );
                    case "Pending":
                      return (
                        <span style={{ cursor: "pointer" }}>
                          <span
                            className="ms-1"
                            onClick={() => headerTabClicked("Queue")}
                          >
                            Queue ({quantityQueued.queuedQty}) |
                          </span>
                          <span
                            className="ms-1"
                            onClick={() => headerTabClicked("Preparing")}
                          >
                            Preparing ({quantityQueued.preparingQty}) |
                          </span>
                          <span
                            className="ms-1"
                            onClick={() => headerTabClicked("Ready")}
                          >
                            Ready ({quantityQueued.readyQty})
                          </span>
                        </span>
                      );
                    case "Preparing":
                      return (
                        <span style={{ cursor: "pointer" }}>
                          <span
                            className="ms-1"
                            onClick={() => headerTabClicked("Queue")}
                          >
                            Queue ({quantityQueued.queuedQty}) |
                          </span>
                          <span
                            className="ms-1"
                            onClick={() => headerTabClicked("Pending")}
                          >
                            Pending ({quantityQueued.pendingQty}) |
                          </span>
                          <span
                            className="ms-1"
                            onClick={() => headerTabClicked("Ready")}
                          >
                            Ready ({quantityQueued.readyQty})
                          </span>
                        </span>
                      );
                    case "Ready":
                      return (
                        <span style={{ cursor: "pointer" }}>
                          <span
                            className="ms-1"
                            onClick={() => headerTabClicked("Queue")}
                          >
                            Queue ({quantityQueued.queuedQty}) |
                          </span>
                          <span
                            className="ms-1"
                            onClick={() => headerTabClicked("Preparing")}
                          >
                            Preparing ({quantityQueued.pendingQty}) |
                          </span>
                          <span
                            className="ms-1"
                            onClick={() => headerTabClicked("Pending")}
                          >
                            Pending ({quantityQueued.pendingQty})
                          </span>
                        </span>
                      );
                  }
                })()}
              </Typography>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleCloseDetailsModel}
                aria-label="close"
              >
                <img src={close} style={{ width: "20px", height: "20px" }} />
              </IconButton>
            </Toolbar>
          </AppBar>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "10px 20px",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {modalData?.length === 0 ? (
                <h4>No order in this queue</h4>
              ) : (
                modalData?.map((order, idx) => (
                  <Card
                    key={idx}
                    className="CardForQueue mb-3"
                    sx={{
                      maxWidth: 345,
                      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                    }}
                  >
                    <OrderDetailsCardContent
                      order={order}
                      reloadData={reloadOrders}
                      restaurantId={restaurantId}
                      kitchenselected={selectedkitchens}
                    />
                  </Card>
                ))
              )}
            </div>
          </Box>

          <div className="full-screen-next-previous-controller-buttons">
            <div
              style={{
                opacity: sectionName === "Queue" ? "0" : "1",
                cursor: sectionName === "Queue" ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (sectionName !== "Queue") {
                  switch (sectionName) {
                    case "Ready":
                      changeModalData(preparingFood, "Preparing");
                      break;
                    case "Preparing":
                      changeModalData(pendingFood, "Pending");
                      break;
                    case "Pending":
                      changeModalData(queuedFood, "Queue");
                      break;
                  }
                }
              }}
            >
              <img
                onClick={() => changeModalData(queuedFood, "Queue")}
                src={previous}
                style={{
                  width: "15px",
                  height: "15px",
                  marginRight: "5px",
                }}
              />
              <span>Previous</span>
            </div>
            <div
              style={{
                opacity: sectionName === "Ready" ? "0" : "1",
                cursor: sectionName === "Ready" ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (sectionName !== "Ready") {
                  switch (sectionName) {
                    case "Pending":
                      changeModalData(preparingFood, "Preparing");
                      break;
                    case "Preparing":
                      changeModalData(readyFood, "Ready");
                      break;
                    default:
                      changeModalData(pendingFood, "Pending");
                      break;
                  }
                }
              }}
            >
              <span>Next</span>
              <img
                src={next}
                style={{
                  width: "15px",
                  height: "15px",
                  marginLeft: "5px",
                }}
              />
            </div>
          </div>
        </Dialog>

        {/* queue Management- 4 rows */}
        <div
          className={` queue-wrapper ${
            horizontalCheck ? "horizontalViewDirection" : ""
          } ${activeTab.length >= 2 ? "center-activation" : ""} ${
            activeTab.length >= 2 ? "center-activation-desktop" : ""
          }`}
        >
          {queuedCheck && (
            <div
              className={`pending-queue ${
                horizontalCheck ? "horizontalView" : ""
              }`}
              style={{ overflowX: "scroll" }}
              ref={QueueRef}
            >
              <div className="mb-3 ">
                <div
                  className="d-flex "
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="d-flex align-items-center">
                    <div className="dot queue-dot"></div>
                    <div className="fw-semibold fs-6 ms-1 queue-status queue-status">
                      Queue
                    </div>
                    <img
                      onClick={() => openDetailsModal(queuedFood, "Queue")}
                      src={fullscreen}
                      style={{
                        width: "20px",
                        height: "18px",
                        marginLeft: "10px",
                        cursor: "pointer",
                      }}
                    />
                  </div>

                  <div className="d-flex align-items-center">
                    <Button
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={(e) => {
                        handleClick(e, 1);
                      }}
                    >
                      <img src={settingsIcon} style={{ width: "1rem" }} />
                    </Button>
                  </div>
                </div>
              </div>
              <div
                className={` ${
                  horizontalCheck
                    ? "d-flex justify-content-center align-items-start  horizontalViewCard"
                    : ""
                }`}
              >
                {queuedFood?.length > 0 ? (
                  queuedFood
                    .sort(
                      (a, b) =>
                        new Date(b.creationDate) - new Date(a.creationDate)
                    ) // Sort descending by date
                    .map((order, idx) => (
                      <Card
                        key={idx} // Always provide a unique key when mapping elements
                        className={`CardForQueue mb-3 ${
                          horizontalCheck ? "horizontalViewCardView" : ""
                        }`}
                        sx={{
                          maxWidth: 345,
                          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        <OrderDetailsCardContent
                          order={order}
                          reloadData={reloadOrders}
                          restaurantId={restaurantId}
                          kitchenselected={selectedkitchens}
                          type={"queued"}
                          readyFoodDetail={readyFood}
                        />
                      </Card>
                    ))
                ) : (
                  <div className="fs-5 text-secondary fw-semibold text-center">
                    No Order in Queue
                  </div>
                )}
              </div>
            </div>
          )}
          {pendingCheck && (
            <div
              className={`pending-queue ${
                horizontalCheck ? "horizontalView" : ""
              }`}
              style={{ overflowX: "scroll" }}
              ref={PendingRef}
            >
              <div
                className="d-flex "
                style={{ justifyContent: "space-between" }}
              >
                <div className="d-flex align-items-center">
                  <div className="dot pending"></div>
                  <div className="fw-semibold fs-6 ms-1 pending-status queue-status">
                    Pending
                  </div>
                  <img
                    onClick={() => openDetailsModal(pendingFood, "Pending")}
                    src={fullscreen}
                    style={{
                      width: "18px",
                      height: "18px",
                      marginLeft: "10px",
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div className="d-flex align-items-center">
                  <Button
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={(e) => {
                      handleClick(e, 2);
                    }}
                  >
                    <img src={settingsIcon} style={{ width: "1rem" }} />
                  </Button>
                </div>
              </div>
              <div
                className={` ${
                  horizontalCheck
                    ? "d-flex justify-content-center align-items-start  horizontalViewCard"
                    : ""
                }`}
              >
                {pendingFood?.length > 0 ? (
                  pendingFood
                    .sort(
                      (a, b) =>
                        new Date(b.creationDate) - new Date(a.creationDate)
                    )
                    .map((order, idx) => (
                      <Card
                        className="CardForQueue mb-3"
                        sx={{
                          maxWidth: 345,
                          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        <OrderDetailsCardContent
                          order={order}
                          //reloadData={getOrdersByOrderStatus}
                          reloadData={reloadOrders}
                          restaurantId={restaurantId}
                          kitchenselected={selectedkitchens}
                          type={"pending"}
                          readyFoodDetail={readyFood}
                        />
                      </Card>
                    ))
                ) : (
                  <div className="fs-5 text-secondary fw-semibold text-center">
                    No Order in Pending
                  </div>
                )}

                {/* {groupedOrdersPending?.length > 0 ? (
                  groupedOrdersPending?.map((order, idx) => (
                    <Card
                      className="CardForQueue mb-3"
                      sx={{
                        maxWidth: 345,
                        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                      }}
                    >
                      <OrderDetailsCardContent
                        order={order}
                        reloadData={getOrdersByOrderStatus}
                        restaurantId={restaurantId}
                      />
                    </Card>
                  ))
                ) : (
                  <div className="fs-5 text-secondary fw-semibold text-center">
                    No Order in Pending
                  </div>
                )} */}
              </div>
            </div>
          )}
          {preparingCheck && (
            <div
              className={`preparing-queue ${
                horizontalCheck ? "horizontalView" : ""
              }`}
              style={{ overflowX: "scroll" }}
              ref={PreparingRef}
            >
              <div
                className="mb-3 d-flex align-items-center"
                style={{ justifyContent: "space-between" }}
              >
                <div className="d-flex align-items-center">
                  <div className="dot preparing"></div>
                  <div className="fw-semibold fs-6 ms-1 queue-status preparing-status">
                    Preparing
                  </div>
                  <img
                    onClick={() => openDetailsModal(preparingFood, "Preparing")}
                    src={fullscreen}
                    style={{
                      width: "18px",
                      height: "18px",
                      marginLeft: "10px",
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div className="d-flex align-items-center">
                  <Button
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={(e) => {
                      handleClick(e, 3);
                    }}
                  >
                    <img src={settingsIcon} style={{ width: "1rem" }} />
                  </Button>
                </div>
              </div>
              <div
                className={` ${
                  horizontalCheck
                    ? "d-flex justify-content-center align-items-start  horizontalViewCard"
                    : ""
                }`}
              >
                {preparingFood?.length > 0 ? (
                  preparingFood
                    .sort(
                      (a, b) =>
                        moment(a.statusChangeDateTime).valueOf() -
                        moment(b.statusChangeDateTime).valueOf()
                    )
                    .map((order, idx) => (
                      <Card
                        className="CardForQueue mb-3"
                        sx={{
                          maxWidth: 345,
                          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        <OrderDetailsCardContent
                          order={order}
                          //reloadData={getOrdersByOrderStatus}
                          reloadData={reloadOrders}
                          restaurantId={restaurantId}
                          kitchenselected={selectedkitchens}
                          type={"preparing"}
                          readyFoodDetail={readyFood}
                        />
                      </Card>
                    ))
                ) : (
                  <div className="fs-5 text-secondary fw-semibold text-center">
                    No Order in Preparing
                  </div>
                )}
              </div>
            </div>
          )}

          {readyCheck && (
            <div
              className={`ready-queue ${
                horizontalCheck ? "horizontalView" : ""
              }`}
              style={{ overflowX: "scroll" }}
              ref={ReadyRef}
            >
              <div className="mb-3 d-flex align-items-center">
                <div className="dot ready"></div>
                <div className="fw-semibold fs-6 ms-1 queue-status ready-status">
                  Ready
                </div>
                <img
                  onClick={() => openDetailsModal(readyFood, "Ready")}
                  src={fullscreen}
                  style={{
                    width: "18px",
                    height: "18px",
                    marginLeft: "10px",
                    cursor: "pointer",
                  }}
                />
              </div>
              <div
                className={` ${
                  horizontalCheck
                    ? "d-flex justify-content-center align-items-start  horizontalViewCard"
                    : ""
                }`}
              >
                {readyFood?.length > 0 ? (
                  readyFood
                    .sort(
                      (a, b) =>
                        moment(a.statusChangeDateTime).valueOf() -
                        moment(b.statusChangeDateTime).valueOf()
                    )
                    .map((order, idx) => (
                      <Card
                        className="CardForQueue mb-3"
                        sx={{
                          maxWidth: 345,
                          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        <OrderDetailsCardContent
                          order={order}
                          //reloadData={getOrdersByOrderStatus}
                          reloadData={reloadOrders}
                          restaurantId={restaurantId}
                          kitchenselected={selectedkitchens}
                          type={"ready"}
                          readyFoodDetail={readyFood}
                        />
                      </Card>
                    ))
                ) : (
                  <div className="fs-5 text-secondary fw-semibold text-center">
                    No Order in Ready
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="orders-queue-button-container-floating">
            {horizontalCheck && (
              <>
                <Button onClick={() => scrollToPreparingQueue("up")}>
                  <img src={downArrow} className="previous-button" /> Previous
                </Button>
                <Button onClick={() => scrollToPreparingQueue("down")}>
                  Next <img src={downArrow} className="next-button" />
                </Button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Queue Setting Modal--it gets open when the settings button got clicked */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box
            sx={{
              ...style,
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            {/* Header and close button */}
            <div className="d-flex justify-content-between align-items-center">
              <h5 style={{ color: "#2a7fd4" }}>
                GoTaste:- Kitchen Settings For{" "}
                {selectedQueue == 1
                  ? "Queue"
                  : selectedQueue == 2
                  ? "Pending"
                  : selectedQueue == 3
                  ? "Preparing"
                  : ""}
              </h5>
              <Button onClick={handleClose}>
                <img src={closeIcon} style={{ width: "1rem" }} />
              </Button>
            </div>

            {/* Kitchen Dropdown */}
            <Grid container>
              <Grid
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  marginTop: ".8rem",
                  alignItems: "center",
                  justifyContent: "start",
                }}
              >
                <Typography sx={{ marginBottom: ".5rem" }}>Kitchen:</Typography>
              </Grid>
              <Grid xs={12} md={8} sx={{ marginTop: ".8rem" }}>
                <AutoCompleteMultiSelect
                  id={33}
                  datas={
                    selectedkitchens.length > 0 ? selectedkitchens : kitchens
                  }
                  value={(e) => {
                    setSelectedKitchenFromModal(e);
                    loadKitchenQueueSettings(e);
                    clearKitchenQueueSettings();
                  }}
                  placeholder={"Select Kitchen"}
                />
              </Grid>
            </Grid>

            {/* Other dropdown / checkbox */}
            {selectedKitchenFromModal && kitchenQueueSettings && (
              <Grid container>
                {/* Max Quantity */}
                <Grid
                  xs={12}
                  md={4}
                  sx={{
                    display: "flex",
                    marginTop: ".8rem",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <Typography sx={{ marginBottom: "0rem" }}>Max Qty</Typography>
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography color="inherit">
                          Max quantity is "unlimited" if the field is empty
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoOutlinedIcon
                      style={{
                        marginLeft: "5px",
                        color: "#371B17",
                        fontSize: 18,
                      }}
                    />
                  </HtmlTooltip>
                  <Typography sx={{ marginBottom: "0rem" }}>:</Typography>
                </Grid>
                <Grid xs={12} md={8} sx={{ marginTop: ".8rem" }}>
                  <TextAreaComponents
                    id={2}
                    val={kitchenQueueSettings?.maxQty}
                    label={"Max Qty"}
                    value={(e) => {
                      setKitchenQueueSettings((prevSettings) => ({
                        ...prevSettings,
                        maxQty: e,
                      }));
                    }}
                  />
                </Grid>

                {/* Auto Accept */}
                <Grid
                  xs={12}
                  md={4}
                  sx={{
                    display: "flex",
                    marginTop: ".8rem",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <Typography sx={{ marginBottom: ".5rem" }}>
                    Auto Accept:
                  </Typography>
                </Grid>
                <Grid xs={12} md={8} sx={{ marginTop: ".8rem" }}>
                  <Switch
                    checked={kitchenQueueSettings?.isAutoAcceptEnable}
                    // onChange={() => {
                    //   setKitchenQueueSettings((prevSettings) => ({
                    //     ...prevSettings,
                    //     isAutoAcceptEnable: prevSettings ? !prevSettings.isAutoAcceptEnable : false,
                    //   }));
                    // }}
                    onChange={() => {
                      setKitchenQueueSettings((prevSettings) => ({
                        ...prevSettings,
                        isAutoAcceptEnable: !prevSettings.isAutoAcceptEnable,
                        autoAcceptFrequency: !prevSettings.isAutoAcceptEnable
                          ? 1
                          : prevSettings.autoAcceptFrequency,
                      }));
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>

                {/* Accept Frequency */}
                <Grid
                  xs={12}
                  md={4}
                  sx={{
                    display: "flex",
                    marginTop: ".8rem",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <div className="d-flex" style={{ flexDirection: "column" }}>
                    <Typography>Accept Frequency :</Typography>
                    <span className="text-muted" style={{ marginTop: "0px" }}>
                      (In Minutes)
                      <HtmlTooltip
                        title={
                          <React.Fragment>
                            <Typography color="inherit">
                              Default Value of auto frequesncy is 1
                            </Typography>
                          </React.Fragment>
                        }
                      >
                        <InfoOutlinedIcon
                          style={{
                            marginLeft: "5px",
                            color: "#371B17",
                            fontSize: 18,
                          }}
                        />
                      </HtmlTooltip>
                    </span>
                  </div>
                </Grid>
                <Grid xs={12} md={8} sx={{ marginTop: ".8rem" }}>
                  <TextAreaComponents
                    id={2}
                    val={kitchenQueueSettings?.autoAcceptFrequency}
                    label={"Auto AcceptFrequency"}
                    // value={(e) => {
                    //   setKitchenQueueSettings((prevSettings) => ({
                    //     ...prevSettings,
                    //     autoAcceptFrequency: e,
                    //   }));
                    // }}
                    value={(e) => {
                      // Prevent the value from being 0
                      const sanitizedValue = e === "0" ? "" : e;

                      setKitchenQueueSettings((prevSettings) => ({
                        ...prevSettings,
                        autoAcceptFrequency: sanitizedValue,
                      }));
                    }}
                    isactive={!kitchenQueueSettings?.isAutoAcceptEnable}
                  />
                </Grid>

                {/* Threshold Quantity */}
                <Grid
                  xs={12}
                  md={4}
                  sx={{
                    display: "flex",
                    marginTop: ".8rem",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <Typography sx={{ marginBottom: ".5rem" }}>
                    Threshold Qty:
                  </Typography>
                </Grid>
                <Grid xs={12} md={8} sx={{ marginTop: ".8rem" }}>
                  <TextAreaComponents
                    id={2}
                    val={kitchenQueueSettings?.threasholdQty}
                    label={"Threashold Qty"}
                    value={(e) => {
                      setKitchenQueueSettings((prevSettings) => ({
                        ...prevSettings,
                        threasholdQty: e,
                      }));
                    }}
                    isactive={!kitchenQueueSettings?.isAutoAcceptEnable}
                  />
                </Grid>

                {/* Wait before increasing with frequency */}
                <Grid
                  xs={12}
                  md={4}
                  sx={{
                    display: "flex",
                    marginTop: ".8rem",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <Typography sx={{ marginBottom: ".5rem" }}>
                    Wait before increasing with frequency:
                  </Typography>
                </Grid>
                <Grid xs={12} md={8} sx={{ marginTop: ".8rem" }}>
                  <Checkbox
                    checked={kitchenQueueSettings?.isThresholdEnable}
                    disabled={
                      !kitchenQueueSettings?.isAutoAcceptEnable ||
                      kitchenQueueSettings?.threasholdQty <= 0 ||
                      kitchenQueueSettings?.autoAcceptFrequency <= 0
                    }
                    onChange={() => {
                      setKitchenQueueSettings((prevSettings) => ({
                        ...prevSettings,
                        isThresholdEnable: !prevSettings.isThresholdEnable,
                      }));
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>

                {/* Close Button, UpdateButton */}
                <Grid
                  md={12}
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    gap: "10px",
                    marginTop: "1rem",
                  }}
                >
                  <Button
                    variant="outlined"
                    color="success"
                    onClick={() => {
                      handleUpdateKitchenSettings();
                    }}
                  >
                    Update{/* update button of model */}
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleClose}
                  >
                    Close {/* close button of model*/}
                  </Button>
                </Grid>
              </Grid>
            )}
          </Box>
        </Fade>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openSettingsModal}
        onClose={() => {
          setOpenSettingsModal(false);
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Box sx={style}>
          {/* <FormControl className="w-100">
            <Grid container>
              <Grid xs={3} className="d-flex mt-1">
                <Typography variant="h6">Queue: </Typography>
              </Grid>
              <Grid xs={9}>
                <FormControlLabel
                  value="Queued"
                  control={
                    <Checkbox
                      checked={queuedCheck}
                      onChange={() => {
                        setQueuedCheck(!queuedCheck);
                      }}
                    />
                  }
                  label="Queued"
                />
                <FormControlLabel
                  value="Pending"
                  control={
                    <Checkbox
                      checked={pendingCheck}
                      onChange={() => {
                        setpendingCheck(!pendingCheck);
                      }}
                    />
                  }
                  label="Pending"
                />
                <FormControlLabel
                  value="Preparing"
                  control={
                    <Checkbox
                      checked={preparingCheck}
                      onChange={() => {
                        setpreparingCheck(!preparingCheck);
                      }}
                    />
                  }
                  label="Preparing"
                />
                <FormControlLabel
                  value="Ready"
                  control={
                    <Checkbox
                      checked={readyCheck}
                      onChange={() => {
                        setreadyCheck(!readyCheck);
                      }}
                    />
                  }
                  label="Ready"
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={3} className="d-flex mt-1">
                <Typography variant="h6">View Type: </Typography>
              </Grid>
              <Grid xs={9}>
                <FormControlLabel
                  value="Row"
                  control={
                    <Checkbox
                      checked={horizontalCheck}
                      onChange={() => {
                        sethorizontalCheck(!horizontalCheck);
                      }}
                    />
                  }
                  label="Row"
                />
              </Grid>
            </Grid>
          </FormControl> */}
          <FormControl className="w-100">
            <Grid container>
              <Grid xs={3} className="d-flex mt-1">
                <Typography variant="h6">Queue: </Typography>
              </Grid>
              <Grid xs={9}>
                <FormControlLabel
                  value="Queued"
                  control={
                    <Checkbox
                      checked={queuedCheck}
                      onChange={() => {
                        setQueuedCheck(!queuedCheck);
                      }}
                    />
                  }
                  label="Queued"
                />
                <FormControlLabel
                  value="Pending"
                  control={
                    <Checkbox
                      checked={pendingCheck}
                      onChange={() => {
                        setpendingCheck(!pendingCheck);
                      }}
                    />
                  }
                  label="Pending"
                />
                <FormControlLabel
                  value="Preparing"
                  control={
                    <Checkbox
                      checked={preparingCheck}
                      onChange={() => {
                        setpreparingCheck(!preparingCheck);
                      }}
                    />
                  }
                  label="Preparing"
                />
                <FormControlLabel
                  value="Ready"
                  control={
                    <Checkbox
                      checked={readyCheck}
                      onChange={() => {
                        setreadyCheck(!readyCheck);
                      }}
                    />
                  }
                  label="Ready"
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={3} className="d-flex mt-1">
                <Typography variant="h6">View Type: </Typography>
              </Grid>
              <Grid xs={9}>
                <FormControlLabel
                  value="Row"
                  control={
                    <Checkbox
                      checked={horizontalCheck}
                      onChange={() => {
                        sethorizontalCheck(!horizontalCheck);
                      }}
                    />
                  }
                  label="Row"
                />
              </Grid>
            </Grid>
          </FormControl>
        </Box>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={kitchenOpenCloseModal}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            setKitchenOpenCloseModal(false);
            setKitchenOpenCloseSwitch(true);
          }
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Box sx={style}>
          <div className="d-flex justify-content-between align-items-center">
            <h5 style={{ color: "#2a7fd4" }}>GoTaste:- Kitchen Settings</h5>
            <Button
              onClick={() => {
                setKitchenOpenCloseModal(false);
                setKitchenOpenCloseSwitch(true);
              }}
            >
              <img src={closeIcon} style={{ width: "1rem" }} />
            </Button>
          </div>
          <Grid container>
            <Box sx={{ width: "100%" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="wrapped label tabs example"
              >
                <Tab value="one" label="Open Kitchens" />
                <Tab value="two" label="Closed Kitchens" />
              </Tabs>
            </Box>
            {value == "one" && (
              <div style={{ width: "100%" }}>
                <Grid xs={12} sx={{ marginTop: ".8rem" }}>
                  <AutoCompleteMultiSelect
                    id={2}
                    datas={openKitchens}
                    value={(e) => {
                      setSelectedKitchensForClosing(e);
                    }}
                    placeholder={"Select Kitchen"}
                    val={selectedkitchensForClosing}
                  />
                </Grid>
                <Grid xs={12} md={12} sx={{ marginTop: ".8rem" }}>
                  <AutoCompleteMultiSelect
                    id={33}
                    placeholder={"Select Closing Reason (Optional)"}
                    datas={cencalationReasons}
                    value={(res) => {
                      setSelectCencalationReason(res);
                    }}
                  />
                </Grid>
                <Grid xs={12} md={12} sx={{ marginTop: ".8rem" }}>
                  <TextAreaComponents
                    id={1}
                    value={(res) => {
                      setRemarks(res);
                    }}
                    label={"Remarks (Optional)"}
                  />
                </Grid>
                <Grid
                  md={12}
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    gap: "10px",
                    marginTop: "1rem",
                  }}
                >
                  <Button
                    variant="outlined"
                    color="success"
                    onClick={() => {
                      handleCloseKitchen(selectedkitchensForClosing, true);
                    }}
                  >
                    Close Kitchen
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                </Grid>
              </div>
            )}
            {value == "two" && (
              <div style={{ width: "100%" }}>
                <Grid xs={12} sx={{ marginTop: ".8rem" }}>
                  <AutoCompleteMultiSelect
                    id={2}
                    datas={closeKitchens}
                    value={(e) => {
                      setSelectedKitchensForClosing(e);
                    }}
                    placeholder={"Select Kitchen"}
                    val={selectedkitchensForClosing}
                  />
                </Grid>
                <Grid
                  md={12}
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    gap: "10px",
                    marginTop: "1rem",
                  }}
                >
                  <Button
                    variant="outlined"
                    color="success"
                    onClick={() => {
                      handleCloseKitchen(selectedkitchensForClosing, false);
                    }}
                  >
                    Open Kitchen
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                </Grid>
              </div>
            )}
          </Grid>
        </Box>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openOrderCancelationModal}
        onClose={handleCloseOrderCancelationModal}
      >
        <Fade in={openOrderCancelationModal}>
          <Box
            sx={{
              ...styleForOrderCancelationModal,
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <h5 style={{ color: "#2a7fd4" }}>
                GoTaste:- Cancel Orders{" "}
                {(() => {
                  switch (selectedQueue) {
                    case 1:
                      return "Queued";
                    case 2:
                      return "Pending";
                    case 3:
                      return "Preparing";
                    default:
                      return "";
                  }
                })()}
              </h5>

              <Button onClick={handleCloseOrderCancelationModal}>
                <img src={closeIcon} style={{ width: "1rem" }} />
              </Button>
            </div>
            <br />
            <Grid container>
              <Grid xs={12} md={12} sx={{ marginTop: ".8rem" }}>
                <AutoCompleteMultiSelect
                  id={33}
                  placeholder={"Select Cancelation Reason (Optional)"}
                  datas={cencalationReasons}
                  value={(res) => {
                    setSelectCencalationReason(res);
                  }}
                />
              </Grid>
              <Grid xs={12} md={12} sx={{ marginTop: ".8rem" }}>
                <TextAreaComponents
                  id={1}
                  value={(res) => {
                    setRemarks(res);
                  }}
                  label={"Remarks (Optional)"}
                />
              </Grid>
              <Grid
                md={12}
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  gap: "10px",
                  marginTop: "1rem",
                }}
              >
                <Button
                  variant="outlined"
                  color="success"
                  onClick={() => {
                    handleCancelOrders();
                  }}
                >
                  Cancel Orders
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={handleCloseOrderCancelationModal}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default OrdersQueue;
